import React, { useEffect, useState } from "react";
import "./style/basketTableStyle.scss";
import { BasketItem } from "../../models/BasketItem";
import "../../../style/block.scss";
import "../../../style/feature.scss";
import "./style/basketItemMobile.scss";
import { HiOutlineTicket } from "react-icons/hi";
import { TicketAccess } from "../../models/TicketAccess";
import { MdOutlineCalendarToday } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import { clearErrors } from "../../store/alerts/alertsActions";
import { useTranslation } from "react-i18next";
import useFacility from "../../../utils/hooks/useFacility";
import EAButton from "../shared/Buttons/EAButton";
import EAQuantitySelector from "../shared/QuantitySelector/EAQuantitySelector";
import format from "date-fns/format";

interface IProps {
  item: BasketItem;
  index: number;
  refreshBasket: Function;
  onRemoveBasket: (index: number) => void;
  handleGetBasket: Function;
  handleAddBasket: (
    assortIds: string,
    assortName: string,
    price: number,
    ticketAccess: TicketAccess | any,
    validFrom: string | null,
    qnt: number | 1
  ) => void;
  isLoading: boolean;
}

const BasketListItemMobile: React.FC<IProps> = ({
  item,
  index,
  onRemoveBasket,
  handleAddBasket,
  handleGetBasket,
  refreshBasket,
  isLoading,
}: IProps) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearErrors());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const facilityIds = useFacility();
  const { t } = useTranslation();
  const [plusAssort, setPlusAssort] = useState<boolean>(true);
  const [minusAssort, setMinusAssort] = useState<boolean>(true);
  const alertLogin = useSelector((state: State) => state.alerts.errors);
  useEffect(() => {
    if (facilityIds === "1220") {
      if (item.assortName === "OPIEKUN OS. Z NIEPEŁNOSPRAWNOŚCIĄ int.") {
        setPlusAssort(false);
        setMinusAssort(true);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    if (facilityIds === "1220") {
      if (item.assortName === "BILET OPIEKUN GRUPY INT.") {
        setPlusAssort(false);
        setMinusAssort(false);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    if (facilityIds === "1224") {
      if (item.assortName === "BILET GRATISOWY") {
        setPlusAssort(false);
        setMinusAssort(true);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    // if (facilityIds === "1214" || facilityIds === "1213" || facilityIds === "1230") {
    //   if (item.assortName === "Opłata internetowa") {
    //     setPlusAssort(false);
    //     setMinusAssort(false);
    //   }
    // }

    if (item.assortName === "Opłata internetowa") {
      setPlusAssort(false);
      setMinusAssort(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  useEffect(() => {
    if (facilityIds === "1228") {
      if (
        item.assortName === "Opiekun Wystawa" ||
        item.assortName === "Opiekun Pracownie" ||
        item.assortName === "Opiekun Edukator" ||
        item.assortName === "Pracownie - lab przedszkolaka opiekun"
      ) {
        setPlusAssort(false);
        setMinusAssort(false);
      }
      if (
        item.assortName === "Asystent Wystawa" ||
        item.assortName === "Asystent Laboratorium" ||
        item.assortName === "Asystent Edukator"
      ) {
        setPlusAssort(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  return (
    <>
      <div className="basket-list-item-mobile">
        <div className="flex-end-center">
          <EAButton
            title={t("usun_z_koszyka")}
            onClick={() => onRemoveBasket(index)}
            disabled={!minusAssort || isLoading}
            variant="text"
          />
        </div>

        <div className="basket-list-item-mobile-body">
          <div className="basket-list-item-mobile-body-name flex-start-center">
            <HiOutlineTicket className="icon" />
            <b>{item.assortName}</b>
          </div>

          <div className="basket-list-item-mobile-body-line"></div>

          <div className="basket-list-item-mobile-body-limited flex-start-center">
            <MdOutlineCalendarToday className="icon" />
            {item.ticketAccess[0] ? (
              <>
                {/* <span>
                  {t("data")}: {item.ticketAccess[0].startDate}
                </span> */}
                <span>
                  {item.ticketAccess[0].exerciseName} | {format(new Date(item.ticketAccess[0].startDate), "yyyy-MM-dd")}
                </span>
              </>
            ) : (
              <div className="flex-start-center basket-list-valid-from">
                <span>
                  {t("wazny_od")}: {item.validFrom}
                </span>
              </div>
            )}
          </div>

          <div className="basket-list-item-mobile-body-price-line flex-between-center">
            <div className="flex-start-center">
              <strong>
                {item.price * item.qnt} {t("zl")}
              </strong>
              <b>
                ({item.price}
                {t("zl")} / {t("szt")})
              </b>
            </div>

            <EAQuantitySelector
              value={item.qnt}
              onChange={() => {}}
              onIncrement={() => {
                if (isLoading) {
                  return;
                }
                handleAddBasket(item.assortIds, item.assortName, item.price, item.ticketAccess, null, 1);
              }}
              onDecrement={() => {
                if (isLoading) {
                  return;
                }
                if (item.qnt === item.minSale) {
                  onRemoveBasket(index);
                } else {
                  handleAddBasket(item.assortIds, item.assortName, item.price, item.ticketAccess, null, -1);
                  dispatch(clearErrors());
                }
              }}
              disabled={true}
              incrementDisabled={!plusAssort || isLoading}
              decrementDisabled={!minusAssort || isLoading}
              min={0}
              max={item.maxSale || 99}
              showMaxInfo={item.maxSale > 0}
            />
          </div>
        </div>
        {alertLogin && alertLogin.length > 5 && <div className="alert alert-red">{alertLogin}</div>}
      </div>
    </>
  );
};

export default BasketListItemMobile;
